import React from 'react';

import Button from '../../../../../components/UI/Button';

import css from '../../FundingAccount.module.scss';

interface LinkProps {
  ready: boolean;
  handleOnClick: () => void;
}

export default function PlaidLinkDefault({ ready, handleOnClick }: LinkProps) {
  return (
    <div>
      <div
        className={`${css.AddFundingAccountContainer} ${css.PlaidFundingAccount}`}
        onClick={handleOnClick}
        data-testid="default-plaid-wrapper"
      >
        <p className={css.recommended} data-e2e="recommended">
          Recommended
        </p>
        <div className={css.AddFundingAccountInfo}>
          <img
            src="../../../../../static/instant_circle.svg"
            className={css.AddFundingAccountItemImage}
            alt="Connect your bank for faster transfers"
          />
          <div style={{ marginLeft: '25px', textAlign: 'left' }}>
            <p
              className={css.AddFundingAccountItemHeader}
              data-e2e="add-plaid-header"
            >
              Add a bank instantly
            </p>
            <p
              className={css.AddFundingAccountItemBody}
              data-e2e="add-plaid-minimum"
            >
              Connect with your bank login credentials*
            </p>
          </div>
        </div>
        <div>
          <Button
            data-e2e="add-plaid-button"
            text="Add bank"
            disabled={!ready}
          />
        </div>
      </div>
    </div>
  );
}
